// Chakra imports
import {Flex, Icon, Text, useColorModeValue} from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import IconBox from "components/Icons/IconBox";
import React, {useEffect, useState} from "react";
import {BsCircleFill} from "react-icons/bs";
import {GrCircleInformation} from "react-icons/gr";
import {getUserId, getUserName} from "../../../../extensions/userInfoExtension";

const Information = ({
                    conversation
                  }) => {
  const textColor = useColorModeValue("gray.700", "white");
  const iconBoxInside = useColorModeValue("white", "white");
  const iconTeal = useColorModeValue("var(--primary-color)", "var(--primary-color)");
  const [userName, setUserName] = useState("onbekend");

  useEffect(() => {
    if(conversation !== undefined || conversation?.userId !== undefined) {
      const userIdWithoutDomain = getUserId().replace(/@.*/, "");
      const userName =
        userIdWithoutDomain === conversation.userId
          ? getUserName()
          : conversation.userId;

      setUserName(userName);
    }
  }, [conversation]);


  return (
    <Card maxW={{sm: "330px", md: "100%"}}>
      <CardBody>
        <Flex justify="space-between" w="100%" minH="190px">
          <Flex direction="column">
            <Flex align="center">
              <IconBox as="box" h={"45px"} w={"45px"} bg={iconTeal} me="16px">
                <GrCircleInformation fontSize={"24px"} color={iconBoxInside}/>
              </IconBox>
              <Flex direction="column">
                <Text color="gray.400" fontWeight="normal" fontSize="md">
                  Titel
                </Text>
                <Text color={textColor} fontWeight="bold" fontSize="xl">
                  {conversation?.title}
                </Text>
              </Flex>
            </Flex>
            <Flex direction="column" mt="36px">
              <Flex align="center">
                <Icon
                  as={BsCircleFill}
                  color="gray.400"
                  w="10px"
                  h="10px"
                  me="8px"
                />
                <Text color={textColor} fontWeight="bold" fontSize="md" mr={"2"}>
                  Gestart door:
                </Text>
                <Text>
                  {userName}
                </Text>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </CardBody>
    </Card>
  );
};

export default Information;
